import { createContext } from "react"

export const RootInitialLoad = createContext(true)
